$(document).ready(function () {
    if ($('#roaming_choose_package_section').hasClass('no-price')) {
        document.getElementById("preiseTable").scrollIntoView();

    }

    $('.roaming_news_wrapper').slick({
        // dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:
            "<button type='button' class='slick-prev pull-left'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
        nextArrow:
            "<button type='button' class='slick-next pull-right'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,
                    // dots: true
                },
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    // infinite: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });

    $('.roaming_btn').on('click', function () {
        let countryId = $('#roaming_countries').val();
        let zoneId = $('#roaming_zones').val();
        
        if(!countryId || !zoneId) {
            countryId = '';
            zoneId = '';
        }

        const href = $(location).attr('href');
        let url = href.split('roaming');
        window.location.href = `${url[0]}roaming/${countryId}/${zoneId}`;
    });

    $('.zone_tabs_wrapper .zone_tab').on('click', function () {
        let zoneId = $(this).attr('id');
        handleZoneTabChange(zoneId);
    });

    $('.zone_select').on('change', function () {
        let zoneId = this.value;
        handleZoneTabChange(zoneId);
    });

    function handleZoneTabChange(zoneId) {
        $('.zone_tabs_wrapper .zone_tab').removeClass('active');
        $(`.zone_select option[value='${zoneId}']`).attr(
            'selected',
            'selected'
        );
        $('#' + zoneId).addClass('active');
        $('.roaming_zone_map_img').removeClass('active');
        $('#map_' + zoneId).addClass('active');
    }

    $('#tab-menu h2').on('click', function () {

        $(this).addClass('active');
        $(this).siblings().removeClass('active');

        $('#preiseTable [role="tabpanel"]').hide()
        $('#panel-'+ $(this).data('type')).show()

        $('#zonenTable .postpaid-zone').hide()
        $('#zonenTable .prepaid-zone').hide()
        $('#zonenTable .'+ $(this).data('type') +'-zone').show()

        if ($(this).data('type') === 'postpaid') {
            $('#roaming-plus').hide()
        } else {
            $('#roaming-plus').show()
        }
    });

    $('.more-info-button-wrapper').on('click', function() {
        const plus = this.querySelector('.plus-img');
        const minus = this.querySelector('.minus-img');
        const dropdown = this.getAttribute('data-target');

        $(minus).toggle();
        $(plus).toggle();
        $(dropdown).toggle();
    });

    const faqItems = document.querySelectorAll('.faq-box');

    faqItems.forEach(item => item.addEventListener('click', () => {

        const answer = item.querySelector('.answer');
        const arrow = item.querySelector('.img_arrow');

        if(answer.style.maxHeight === '100vh'){
            answer.style.maxHeight = '0vh';
            arrow.style.transform = 'rotate(0deg)';
        } else {
            answer.style.maxHeight = '100vh';
            arrow.style.transform = 'rotate(180deg)';
        }
    }));
});
